import React, { useRef } from "react";
import { Menubar } from "primereact/menubar";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { classNames } from "primereact/utils";

export default function Header(props) {
  const items = [
    {
      label: "File",
      icon: "pi pi-fw pi-file",
      items: [
        {
          label: "New",
          icon: "pi pi-fw pi-plus",
          items: [
            {
              label: "Bookmark",
              icon: "pi pi-fw pi-bookmark",
            },
            {
              label: "Video",
              icon: "pi pi-fw pi-video",
            },
          ],
        },
        {
          label: "Delete",
          icon: "pi pi-fw pi-trash",
        },
        {
          separator: true,
        },
        {
          label: "Export",
          icon: "pi pi-fw pi-external-link",
        },
      ],
    },
    {
      label: "Quit",
      icon: "pi pi-fw pi-power-off",
    },
  ];

  const start = (
    <div className="flex items-center">
      {!props.hidden && (
        <>
          <Button
            icon="pi pi-bars"
            text
            severity="secondary"
            className="!h-10 !w-10 !p-0"
            aria-label="Icon"
            onClick={() => props.setShowSidebar(!props.showSidebar)}
          />
        </>
      )}
      <img
        className="!mx-2 h-7 w-auto"
        src={require("../../assets/syaamil-group.png")}
        alt="Syaamil Group"
      />
    </div>
  );

  const menu_profie = useRef(null);

  let item_profile = [
    { label: "Profile", icon: "pi pi-fw pi-user", className: "syspro" },
    { label: "Settings", icon: "pi pi-fw pi-cog", className: "syspro" },
    { separator: true },
    {
      className: "syspro",
      command: () => {
        // toast.current.show({
        //   severity: "info",
        //   summary: "Info",
        //   detail: "Item Selected",
        //   life: 3000,
        // });
        alert("haha");
      },
      template: (item, options) => {
        return (
          <div className={classNames(options.className, "flex")}>
            <Avatar
              image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png"
              className="mr-2"
              shape="circle"
            />
            <div className="flex flex-col">
              <span className="text-sm font-bold">Irsyad Nurdin</span>
              <span className="text-xs">Agent</span>
            </div>
          </div>
        );
      },
    },
  ];

  const end = (
    <>
      <Menu model={item_profile} popup={true} ref={menu_profie} />
      <Avatar
        icon="pi pi-user"
        shape="circle"
        onClick={(e) => menu_profie.current.toggle(e)}
      />
    </>
  );

  return (
    <>
      <Menubar
        start={start}
        // model={items}
        end={end}
        className="syspro justify-between !rounded-none !p-1"
      />
    </>
  );
}
